import {
  headersContainPseudoHeader,
  type HttpHeaderPair,
  type HttpHeaders,
} from './http-pseudo-header.utils';

export function normalizeHarHttpVersion(
  httpVersion: string | undefined,
): string {
  if (!httpVersion) {
    return 'HTTP/1.1';
  }

  const normalizedVersion = httpVersion.toUpperCase();
  if (
    normalizedVersion === 'H2' ||
    normalizedVersion === 'H2C' ||
    normalizedVersion === 'HTTP2'
  ) {
    return 'HTTP/2.0';
  }
  if (normalizedVersion === 'H1' || normalizedVersion === 'HTTP1') {
    return 'HTTP/1.1';
  }
  if (normalizedVersion === 'H3' || normalizedVersion === 'HTTP3') {
    return 'HTTP/3.0';
  }

  return normalizedVersion.startsWith('HTTP/')
    ? normalizedVersion
    : `HTTP/${normalizedVersion}`;
}

export function replayProtocolFromHttpVersion(
  httpVersion: string | undefined,
): 'http1' | 'http2' {
  return isHttp2Version(httpVersion) ? 'http2' : 'http1';
}

export function normalizeHttpVersionNumber(
  httpVersion: string | undefined,
): string {
  return normalizeHarHttpVersion(httpVersion).replace(/^HTTP\//, '');
}

export function isHttp2Version(httpVersion: string | undefined): boolean {
  const normalizedVersion = normalizeHarHttpVersion(httpVersion);
  return normalizedVersion.startsWith('HTTP/2');
}

function isHttp1LikeVersion(httpVersion: string | undefined): boolean {
  const normalizedVersion = normalizeHarHttpVersion(httpVersion);
  return (
    normalizedVersion === 'HTTP/1.1' ||
    normalizedVersion === 'HTTP/1.0' ||
    normalizedVersion === 'HTTP/1'
  );
}

export function resolveEffectiveHttpVersion({
  httpVersion,
  headers,
}: {
  httpVersion?: string;
  headers?: HttpHeaderPair[] | HttpHeaders | string[];
}): string {
  if (isHttp1LikeVersion(httpVersion) && headersContainPseudoHeader(headers)) {
    return 'HTTP/2.0';
  }

  return normalizeHarHttpVersion(httpVersion);
}
